
const serverInformationUpdateInterval = 300000;
const serverInformationUpdateFirstTime = 5000;

export class ServerInformationService {
  constructor($http, RouterService) {
    this.$http = $http;
    this.usage = null;
    if (!RouterService.pdf) this.scheduleUpdate(serverInformationUpdateFirstTime);
  }

  update() {
    return this.$http.get('/analytics/server-information')
      .then((result) => {
        this.databaseUsage = result.data.databaseUsage;
        this.databasePath = result.data.databasePath;
        this.databaseAlarm = result.data.databaseAlarm;
        this.hddUsage = result.data.hddUsage;
        this.hddAlarm = result.data.hddAlarm;
        this.hddHardLimit = result.data.hddHardLimit;
        this.clickhouseUsage = result.data.clickhouseUsage;
        this.clickhousePath = result.data.clickhousePath;
        this.needApplySchedule = result.data.needApplySchedule;
      })
      .catch(({status}) => {
        console.error('HTTP error: ' + status);
      })
      .then(() => {
        this.scheduleUpdate();
      })
      ;
  }

  scheduleUpdate(timeout) {
    setTimeout(() => this.update(), timeout || serverInformationUpdateInterval);
  }
}



// WEBPACK FOOTER //
// ./src/core/server-information.service.js